namespace MACRAIL.UI {

export class HelpTips {

    private json?: object;

    private qTip: QTip2.Api;

    constructor (rootElement: JQuery, file: string) {

        this.qTip = MACRAIL.Helpers.createQtip({
            'target': $('<div />'),
            'position': 'below',
            'class': 'info',
            'extraClasses': 'helptip',
            'title': 'Help',
            'content': 'PLACEHOLDER',
        });

        $.getJSON(file, (data: HelpFile, textStatus: string, jqXHR: JQueryXHR) => {
            this.json = data;

            for (let id in data) {
                if (!data.hasOwnProperty(id)) {
                    continue;
                }

                let element = $(`label[for="${id}"]`);

                if (element.length === 0) {
                    element = $(`#${id}`);
                }

                if (element.length === 0) {
                    continue;
                }

                let icon = $(`<i class="fa fa-question-circle-o helptip-icon highlight-info" data-slug="${id}"></i>`);
                element
                    .prepend(' ')
                    .prepend(icon)
                    .css('position', 'relative');

                icon.on('click', (e) => {
                    let iconEl = $(e.target);
                    let slug = iconEl.data('slug');

                    let help = data[slug];

                    let desc = help.desc.replace(/\n/g, '</p><p>');

                    let content = `<div>Description</div><p>${desc}</p>`;

                    if (help.say) {
                        content += `<div>Say</div><p>"${help.say}"</p>`;
                    }
                    if (help.example) {
                        content += `<div>Example</div><p>${help.example}</p>`;
                    }

                    let title = iconEl.parent().text();

                    this.qTip.set('content.title', title);
                    this.qTip.set('content.text', content);
                    this.qTip.set('position.target', icon);
                    this.qTip.set('show.target', icon);
                    this.qTip.show();

                    e.preventDefault();
                    e.stopPropagation();
                });
            }
        });
    }
}

}

interface HelpFile {
    [id: string]: HelpFileItem;
}

interface HelpFileItem {
    desc: string;
    say?: string;
    example?: string;
}
